/**
 * CA Registration OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RegistrationRequestDto { 
    appVersion: RegistrationRequestDto.AppVersionEnum;
    email: string;
    name?: string;
    phone?: string;
}
export namespace RegistrationRequestDto {
    export type AppVersionEnum = 'OWNER' | 'FARM';
    export const AppVersionEnum = {
        OWNER: 'OWNER' as AppVersionEnum,
        FARM: 'FARM' as AppVersionEnum
    };
}


